export const wpjslibData = {
    wpjslib6Url: 'https://std.wpcdn.pl/wpjslib6/wpjslib-ecom.js',
    wp_pp_gemius_identifier: 'p9NKgXNbT3xO7qNM0YwzaMcPfXVk0eOKdIIcZ68B0lX.97',
    wp_sn: 'noc_nocowanie',
};
